import AircraftComfort from './AircraftComfort';
export default AircraftComfort;
